/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: file-system-edit-service.ts
 *
 * Created by kyang on 2020-09-11.
 */

angular.module('prism-ui.fileSystem').service('FileSystemEditService', function (
    this: JS5Object,
    _: JS5Object,
) {
    this.editorForm = null;
    this.originalEditData = null;

    this.setOriginalEditData = (fileSystem: JS5Object) => {
        this.originalEditData = _.cloneDeep(fileSystem);
        _.invoke(this, 'editorForm.$setPristine');
    };
});
